import { NumberObject } from '@/common/types/number-object';
import { isNotInventoryFilterColor } from './is-inventory-filter-color';

/**
 * Calculates the count for "Others" category and merges it with the existing color counts.
 *
 * @param categoryFiltersCount Original count mapping for all colors
 * @returns Updated count mapping including "Others" category
 */
export function getAdjustedColorsFilterCount(
  categoryFiltersCount: NumberObject
): NumberObject {
  if (!categoryFiltersCount) {
    return {};
  }

  // Initialize the adjusted counts with the existing valid color counts
  const adjustedCounts: NumberObject = {};
  let othersCount = 0;

  // Process each color in the original counts
  Object.entries(categoryFiltersCount).forEach(([color, count]) => {
    if (isNotInventoryFilterColor(color)) {
      // Accumulate count for non-standard colors into Others
      othersCount += count;
    } else {
      // Preserve counts for standard colors
      adjustedCounts[color] = count;
    }
  });

  // Add Others count if there are any non-standard colors
  adjustedCounts['Others'] = othersCount;

  return adjustedCounts;
}
